<div class="container-fluid">
  <ngx-alerts></ngx-alerts>
  <app-pagetitle
    [title]="'Showing Trouble Codes of: '+name"></app-pagetitle>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
                   style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light">
              <tr>
                <th>S.No.</th>
                <th>Trouble Code</th>
                <th>DTC Number</th>
                <th>Error Desc</th>
                <th>Distance Travelled With MIL ON</th>
                <th>CreatedOn</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of vehicleAlerts; let i= index">
                <td>{{i + 1}}</td>
                <td>{{item.troubleCode}}</td>
                <td>{{item.dtcNumber}}</td>
                <td>{{item.errorDesc}}</td>
                <td>{{item.distanceTraveledWithMILOn}}</td>
                <td>{{item.createdOn}}</td>
              </tr>
              </tbody>
            </table>
            <mat-paginator (page)="pageEvent = getServerData($event)" [length]="totalRecords"
                           [pageSize]="search.size"
                           [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
